/**
 * vue 基础库
 */
(function (global, factory) {
    var theExports = null;
    var hasModuleExports = false;
    if (typeof module === 'object' && typeof module.exports === 'object') {
        theExports = module.exports;
        hasModuleExports = true;
    } else {//导出为模块
        theExports = global['App_Vues'] = {};
    }
    factory(theExports, hasModuleExports);
}(typeof window !== 'undefined' ? window : this, function (exports, hasModuleExports) {
    exports.__name__ = 'App_Vues';
    //
    if (hasModuleExports) {
        console.log('以模块方式导入[' + exports.__name__ + ']');
    } else {
        console.log('以普通方式导入[' + exports.__name__ + ']');
    }
    //---------------------------------------------------------------------------------
    let {Utils, $, Ajax, H5file} = require('./app.base');
    let appConf = require('./app.conf');
    //---------------------------------------------------------------------------------

    let PopperJS = window.Popper || require('./popper');
    if (typeof PopperJS == 'undefined') {
        console.error('缺少 common/popper.js');
    }

    let Vue = window.Vue || require('vue');
    if (typeof Vue == 'undefined') {
        console.error('缺少 vue/vue.js');
    }

    let __initZIndex = 1000;
    let ELEMENT = window.ELEMENT || require('element-ui');
    if (typeof ELEMENT == 'undefined') {
        console.error('缺少 vue-ui/index.js');
    } else {
        Vue.use(ELEMENT, {size: 'small', zIndex: __initZIndex});
    }

    let VueRouter = window.VueRouter || require('vue-router');
    if (typeof VueRouter == 'undefined') {
        console.error('缺少 vue/vue-router.js');
    } else {
        Vue.use(VueRouter);
    }

    let VueLazyload = window.VueLazyload || undefined //require('vue-lazyload');
    if (typeof VueLazyload == 'undefined') {
        console.warn('缺少 vue/vue-lazyload.js');
    } else {
        Vue.use(VueLazyload);
    }

    let Sortable = window.Sortable || undefined //require('sortablejs');
    if (typeof Sortable == 'undefined') {//vuedraggable的依赖
        console.error('缺少 common/sortable.js');
    }

    let vuedraggable = window.vuedraggable || undefined //require('vuedraggable');
    if (typeof vuedraggable == 'undefined') {
        console.error('缺少 vue/vuedraggable.js');
    } else {
        Vue.component('draggable', vuedraggable);
    }


    //
    let _VirtualScrollAll = window['el-table-virtual-scroll'] || undefined //require('el-table-virtual-scroll');
    let VirtualScroll = null;
    let VirtualColumn = null;
    if (typeof _VirtualScrollAll == 'undefined') {
        console.warn('缺少 vue/vue-vscroll.js');
    } else {
        VirtualScroll = _VirtualScrollAll['VirtualScroll'];
        VirtualColumn = _VirtualScrollAll['VirtualColumn'];
        console.info('virtual scroll and column script ok');
    }
    //
    let JsonViewer = window.JsonView && JsonView.default ? JsonView.default : undefined // require('vue-json-viewer');
    if (JsonViewer) {
        Vue.use(JsonViewer);
    }
    //扩充注册函数
    let compRegistFlagMap = {}; //已注册组件标记
    Vue.regist = function (component) {
        if (component == null) {
            console.warn('所要注册的路由组件 尚未加载（往往是因为存在双向依赖导致的）');
        } else {
            let compName = component.name || null;
            if (compName == null) {
                console.error('所要注册的组件 缺少有效 name 属性');
                return;
            }
            if (compRegistFlagMap[compName] == null) {
                if (typeof component != 'function') {//普通对象注册（而非异步组件）
                    if (component.template == null && component.autoTemplateId == true) {
                        //自动添加模板id（格式 #tpl-{name}）
                        component.template = '#tpl-' + compName;
                        //
                        console.debug('已为组件 <' + compName + '> 自动补充 template : ' + component.template);
                    }
                }
                Vue.component(compName, component);
                compRegistFlagMap[compName] = true;
            } else {
                console.warn('组件 <' + compName + '> 已经注册过了');
            }
        }
    };

    // -----------------------------------------
    var __vue_router = null;

    function setRouter(router) {
        __vue_router = router;
    }

    //扩展Vue原型，统一获取$router（兼容不是路由的场景）
    Vue.prototype.$getRouter = function () {
        return this.$router || __vue_router;
    }

    //扩展Vue原型，统一获取query（兼容不走路由的场景）
    Vue.prototype.$getRouteQuery = function () {
        if (this.$route) {
            return this.$route.query || {};
        } else {
            return this.$attrs.query || {};
        }
    }

    //
    let Routes = window.Routes || require('web-common/dist/routes');
    if (typeof Routes == 'undefined') {
        console.error('缺少 common/routes.js');
    } else {
        Routes.setRegistFunction(Vue.regist);
    }

    //
    function ajaxErrorCallback(message, errid) {
        Vue.prototype.$message.error(message + (errid == null ? '' : '(' + errid + ')'));
    }

    //
    Ajax.errorCallback(ajaxErrorCallback);

    // https://cn.vuejs.org/v2/guide/custom-directive.html
    const htmlTagNameUrlAttrMap = {
        'IMG': 'src',
        'A': 'href',
        'LINK': 'href',
        'SCRIPT': 'src',
        'FORM': 'action',
        'IFRAME': 'src',
        'FRAME': 'src',
        'BASE': 'href',
        'AUDIO': 'src',
        'VIDEO': 'src',
        'SOURCE': 'src',
        'TRACK': 'src',
        'EMBED': 'src',
        'OBJECT': 'codebase'
    };

    function getElUrlAttr(el = null) {
        let defaultUrlAttr = 'data-url';
        //
        if (el !== null) {
            let attrName = htmlTagNameUrlAttrMap[el.tagName];
            return typeof attrName == 'undefined' ? defaultUrlAttr : attrName;
        }
        return defaultUrlAttr;
    }

    function asHashedUrl(url = '') {
        let hashValue = Number(new Date());
        if (url.lastIndexOf('?') != -1) {
            if (!url.endsWith('?')) {
                url = url + '&'
            }
        } else {
            url = url + '?';
        }
        return url + hashValue;
    }

    // -----------------------------------
    let setAppUrl = function (el, binding) {
        //console.log(binding);
        let url = binding.value || '';
        let attr = binding.arg || getElUrlAttr(el);
        let hash = (binding.modifiers || {}).hash || false;
        //
        let resultUrl = url.startsWith('http') ? url : '' + url;
        if (typeof getAppUrl == 'function') {
            resultUrl = getAppUrl(url);
        }
        if (hash === true) {
            resultUrl = asHashedUrl(resultUrl);
        }
        //
        el.setAttribute(attr, resultUrl);
    };

    Vue.directive('app-url', {
        bind: setAppUrl,
        insert: setAppUrl,
        update: setAppUrl
    });

    // -----------------------------------
    let setRescUrl = function (el, binding) {
        //console.log(binding);
        let url = binding.value || '';
        let attr = binding.arg || getElUrlAttr(el);
        let hash = (binding.modifiers || {}).hash || false;
        //
        let resultUrl = url.startsWith('http') ? url : '/resc' + url;
        if (typeof getRescUrl == 'function') {
            resultUrl = getRescUrl(url);
        }
        if (hash === true) {
            resultUrl = asHashedUrl(resultUrl);
        }
        //
        el.setAttribute(attr, resultUrl);
    };

    Vue.directive('resc-url', {
        bind: setRescUrl,
        insert: setRescUrl,
        update: setRescUrl
    });

    // -----------------------------------
    let setAppxUrl = function (el, binding) {
        //console.log(binding);
        let url = binding.value || '';
        let attr = binding.arg || getElUrlAttr(el);
        let hash = (binding.modifiers || {}).hash || false;
        //
        let resultUrl = url.startsWith('http') ? url : '/appx' + url;
        if (typeof getAppxUrl == 'function') {
            resultUrl = getAppxUrl(url);
        }
        if (hash === true) {
            resultUrl = asHashedUrl(resultUrl);
        }
        //
        el.setAttribute(attr, resultUrl);
    };

    Vue.directive('appx-url', {
        bind: setAppxUrl,
        insert: setAppxUrl,
        update: setAppxUrl
    });

    // 仅供测试用（需要定义getSrcUrl()）
    let setSrcUrl = function (el, binding) {
        if (appConf.CUR_ENV !== 'test') {
            console.error('src-url 指令仅能在本地测试模式（test）下使用！');
        }
        //
        //console.log(binding);
        let url = binding.value || '';
        let attr = binding.arg || getElUrlAttr(el);
        let hash = (binding.modifiers || {}).hash || false;
        //
        let resultUrl = url.startsWith('http') ? url : '/src' + url;
        if (typeof getSrcUrl == 'function') {
            resultUrl = getSrcUrl(url);
        }
        if (hash === true) {
            resultUrl = asHashedUrl(resultUrl);
        }
        //
        el.setAttribute(attr, resultUrl);
    };
    Vue.directive('src-url', {
        bind: setSrcUrl,
        insert: setSrcUrl,
        update: setSrcUrl
    });

    // v-dialog-draggable: 弹窗拖拽指令
    Vue.directive('dialog-draggable', {
        bind: function (el, binding, vnode, oldVnode) {
            var dialogHeaderEl = el.querySelector('.el-dialog__header');
            var dragDom = el.querySelector('.el-dialog');
            //dialogHeaderEl.style.cursor = 'move';
            dialogHeaderEl.style.cssText += ';cursor:move;'
            dragDom.style.cssText += ';top:0px;'

            // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
            var sty = (function () {
                if (window.document.currentStyle) {
                    return function (dom, attr) {
                        return dom.currentStyle[attr]
                    };
                } else {
                    return function (dom, attr) {
                        return getComputedStyle(dom, false)[attr]
                    };
                }
            })();

            dialogHeaderEl.onmousedown = function (e) {
                // 鼠标按下，计算当前元素距离可视区的距离
                var disX = e.clientX - dialogHeaderEl.offsetLeft;
                var disY = e.clientY - dialogHeaderEl.offsetTop;

                var screenWidth = document.body.clientWidth; // body当前宽度
                var screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)

                var dragDomWidth = dragDom.offsetWidth; // 对话框宽度
                var dragDomheight = dragDom.offsetHeight; // 对话框高度

                var minDragDomLeft = dragDom.offsetLeft;
                var maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;

                var minDragDomTop = dragDom.offsetTop;
                var maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight;

                // 获取到的值带px 正则匹配替换
                var styL = sty(dragDom, 'left');
                var styT = sty(dragDom, 'top');

                // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
                if (styL.includes('%')) {
                    styL = +document.body.clientWidth * (+styL.replace(/\%/g, '') / 100);
                    styT = +document.body.clientHeight * (+styT.replace(/\%/g, '') / 100);
                } else {
                    styL = +styL.replace(/px/g, '');
                    styT = +styT.replace(/px/g, '');
                }

                document.onmousemove = function (e) {
                    // 通过事件委托，计算移动的距离
                    var left = e.clientX - disX;
                    var top = e.clientY - disY;

                    // 边界处理
                    if (-(left) > minDragDomLeft) {
                        left = -(minDragDomLeft);
                    } else if (left > maxDragDomLeft) {
                        left = maxDragDomLeft;
                    }

                    if (-(top) > minDragDomTop) {
                        top = -(minDragDomTop);
                    } else if (top > maxDragDomTop) {
                        top = maxDragDomTop;
                    }

                    // 移动当前元素
                    dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`;
                };

                document.onmouseup = function (e) {
                    document.onmousemove = null;
                    document.onmouseup = null;
                };

            };
        },
        unbind: function (el, binding, vnode) {
            var dialogHeaderEl = el.querySelector('.el-dialog__header');
            dialogHeaderEl.onmousedown = null;
        }
    });

    // el-table 行拖拽指令（ 绑定表达式写法：v-row-draggable="makeDragCtxData()" ）
    // makeDragCtxData 返回拖拽上下文信息 { context : this, provider(), callback(dataList, newIndex) }
    Vue.directive('row-draggable', {
        bind: function (el, binding, vnode) {
            //console.log(el);
            //console.log(binding);
            let dragCtxData = binding.value || {};
            let context = dragCtxData['context'] || null;
            let provider = dragCtxData['provider'] || null;
            let callback = dragCtxData['callback'] || null;
            if (typeof context == 'undefined' || context == null) {
                console.warn('缺少函数掉调用上下文对象 context');
            }
            if (typeof provider != 'function') {
                console.error('缺少拖拽条目数据[]的提供函数 provider');
                return;
            }
            if (typeof callback != 'function') {
                console.warn('缺少拖拽后条目数据[]的回调函数 callback(dataList)');
            }
            //
            let tblElem = el.querySelector('.el-table__body-wrapper table');
            if (tblElem == null) {
                console.warn('绑定表格拖动行为失败（未找到 table body）');
                return;
            }
            let tblBody = tblElem.tBodies[0];
            //hold sortable
            el.sortable = Sortable.create(tblBody, {
                animation: 1000,
                draggable: 'tr',
                ghostClass: 'sortable-ghost',
                onMove: function (evnt) {
                    //无有效数据则取消拖拽
                    let dataList = provider.call(context);
                    return dataList != null;
                },
                onEnd: function (evnt) {
                    let dataList = provider.call(context);
                    if (dataList) {
                        let oldIndex = evnt.oldIndex;
                        let newIndex = evnt.newIndex;
                        //
                        let oldItem = dataList.splice(oldIndex, 1)[0];
                        dataList.splice(newIndex, 0, oldItem);
                        if (typeof callback == 'function') {
                            callback.call(context, dataList, newIndex);
                        } else {
                            console.log('条目已经移动到第 ' + (newIndex + 1) + ' 行');
                        }
                    }
                }
            });
        },
        unbind: function (el, binding, vnode) {
            //destroy sortable
            el.sortable.destroy();
        }
    });


    //结合ELEMENT-UI和自定义弹层的的zIndex 管理器
    let zIndexManager = {
        zIndex: 1000,
        //所有zIndex要计算在内的选择器
        selectors: [],
        //所有zIndex要计算在内的选择器缓存
        selectorStr: null,
        addSelectors: function () {
            let selectors = arguments;
            for (let i = 0, c = selectors.length; i < c; i++) {
                let selector = selectors[i];
                if (this.selectors.indexOf(selector) === -1) {
                    this.selectors.push(selector);
                    console.log('注册 zIndex 选择器：' + selector);
                }
            }
            this.selectorStr = this.selectors.join(', ');
            console.log('zIndex 选择器表达式：' + this.selectorStr);
        },
        //下个新的zIndex
        nextZIndex: function (noneElCtrl) {
            this.zIndex++;
            //
            if (this.selectorStr) {
                let allPopups = $(this.selectorStr);
                let maxZIndex = 0;
                let tmpZIndex = 0;
                allPopups.each(function (idx, popup) {
                    tmpZIndex = parseInt(popup.style.zIndex || 0);
                    if (tmpZIndex > maxZIndex) {
                        maxZIndex = tmpZIndex;
                    }
                });

                if (maxZIndex >= this.zIndex) {
                    this.zIndex = maxZIndex + 1;
                }
            }
            console.log('next zIndex => ' + this.zIndex);
            if (noneElCtrl) {
                Vue.prototype.$ELEMENT.zIndex = this.zIndex + 1;
                console.log('elui zIndex => ' + this.zIndex);
            }
            //
            return this.zIndex;
        },
        initialize: function () {
            this.zIndex = __initZIndex;
            //
            console.log('init zIndex =>' + this.zIndex);
            //所有zIndex要计算在内的选择器（注意：不用包含 tool-tip, menu等鼠标离开后就关闭的组件）
            this.addSelectors('div.el-dialog__wrapper', 'div.el-message-box__wrapper', 'div.el-drawer__wrapper', 'div.el-notification', 'div.el-popper', 'div[name="route-layer-wrapper"]');
            //
            this.nextZIndex();
        }
    };
    //
    zIndexManager.initialize();

    //生成对话框占位符
    function createDialogHolder() {
        let dlgDomId = 'dlg-' + Number(new Date()) + '-' + parseInt(Math.random() * 1000) + '-' + parseInt(Math.random() * 1000);
        let dlgDom = document.createElement('div');
        dlgDom.id = dlgDomId;
        dlgDom.style.display = 'none';
        document.body.appendChild(dlgDom);
        //
        return dlgDom;
    }

    function adjustJqDialogSize(dlgRoot, size, showDlgTitle, showDlgFoot, centerButtons) {
        size = size || {};
        showDlgTitle = showDlgTitle != false;
        showDlgFoot = showDlgFoot != false;
        centerButtons = centerButtons == true;
        //
        let jqWin = $(window);
        let winWth = jqWin.width() - 2;
        let winHgt = jqWin.height() - 2;
        //
        let width = size.width || '50%';
        let height = size.height || '50%';
        if (typeof width == 'number') {
            if (width < 0) {//处理负值
                width = winWth + width;
            }
        }
        if (typeof height == 'number') {
            if (height < 0) {//处理负值
                height = winHgt + height;
            }
        }
        let widthX = typeof width === 'number' ? width : winWth * parseInt(width) / 100;
        let heightX = typeof height === 'number' ? height : winHgt * parseInt(height) / 100;
        widthX = Math.min(widthX, winWth);
        heightX = Math.min(heightX, winHgt);
        //
        //console.log(heightX);
        //
        dlgRoot.width(widthX);
        dlgRoot.height(heightX);
        let left = parseInt(winWth / 2 - widthX / 2);
        let top = parseInt(winHgt / 2 - heightX / 2);
        dlgRoot.css('left', left);
        dlgRoot.css('transform', 'none');//!!!
        //
        dlgRoot.css('top', top);
        //
        let dlgHeader = dlgRoot.find('>.el-dialog__header');
        let dlgFooter = dlgRoot.find('>.el-dialog__footer');
        let dlgBody = dlgRoot.find('>.el-dialog__body');
        //
        dlgHeader.css('display', showDlgTitle ? '' : 'none');
        dlgFooter.css('display', showDlgFoot ? '' : 'none');
        if (centerButtons) {
            dlgFooter.css('text-align', 'center');
        }
        //
        let headerHgt = showDlgTitle ? 41 : 0;
        let footerHgt = showDlgFoot ? 63 : 0;
        //
        let bodyPaddingHr = 20 * 2;
        let bodyPaddingVt = 18 * 2;
        let bodyWidth = widthX - bodyPaddingHr;
        let bodyHeight = heightX - headerHgt - footerHgt - bodyPaddingVt;
        //console.log("bodyHeight :" + bodyHeight);
        dlgBody.width(bodyWidth);
        dlgBody.height(bodyHeight);
        //大小、位置 调整后显示
        dlgRoot.css('visibility', 'visible');
    }

    // ---------------------------------------------------

    /** 确保把字符串形式的数据转为json数组 */
    function castToJsonArray(theList) {
        theList = theList || [];
        if (typeof theList == 'string') {
            theList = theList.trim();
            if (theList == '') {
                theList = [];
            } else {//解析json字符串
                try {
                    theList = JSON.decode(theList);
                } catch (ex) {
                    theList = [];
                    console.error('json数组格式错误');
                }
            }
        }
        //
        return theList;
    }

    // ---------------------------------------------------
    //clicked('ok|cancel|ext'), okClicked('ok'), cancelClicked('cancel'), extClicked('ext'), onClosed('ok|cancel|ext|X')
    //lifecycle {created, mounted, beforeDestroy, destroyed}
    //title, width, height, template, data, methods, okClicked, cancelClicked, extClicked, lifecycle , showCloseBtn , showTitle
    let showDialog = function (dlgConfig) {
        dlgConfig = dlgConfig || {};
        //
        let errid = dlgConfig['errid'] || null;
        //
        let showDlgTitle = dlgConfig['showTitle'] !== false;
        let showHelpIcon = dlgConfig['showHelpIcon'] === true;
        //
        let dlgTitle = dlgConfig['title'] || '通用对话框';
        let dlgSubTitle = dlgConfig['subTitle'] || null;
        if (dlgSubTitle == null) {
            let tmpIndex = dlgTitle.indexOf('|');
            if (tmpIndex != -1) {
                dlgSubTitle = dlgTitle.substring(tmpIndex + 1).trim() || null;
                dlgTitle = dlgTitle.substring(0, tmpIndex).trim();
            }
        }
        let dlgWidth = dlgConfig['width'] || '50%';
        let dlgHeight = dlgConfig['height'] || '50%';
        let dlgTemplate = dlgConfig['template'] || '<template>缺少内容模板</template>';
        if (dlgTemplate.charAt(0) == '#') {
            let tplDomId = dlgTemplate.substring(1);
            let tplDom = document.getElementById(tplDomId);
            if (tplDom != null && tplDom.tagName) {
                dlgTemplate = tplDom.innerHTML;
                console.info('从 dom <' + tplDom.tagName.toLowerCase() + ' id="' + tplDomId + '" ..> 中提取了模版内容');
            }
        }
        let dlgData = dlgConfig['data'] || {};
        let dlgMethods = dlgConfig['methods'] || {};
        let dlgClickCback = dlgConfig['clicked'];
        let dlgOkCallback = dlgConfig['okClicked'] || dlgClickCback || null;
        let dlgCancelCallback = dlgConfig['cancelClicked'] || dlgClickCback || null;
        let dlgExtCallback = dlgConfig['extClicked'] || dlgClickCback || null;
        //
        let dlgOkText = dlgConfig['okText'] || '确 定';
        let dlgCancelText = dlgConfig['cancelText'] || '取 消';
        let dlgExtText = dlgConfig['extText'] || '其 他';
        //
        let dlgOkVisible = dlgConfig['okVisible'] !== false;
        let dlgCancelVisible = dlgConfig['cancelVisible'] !== false;
        let dlgExtVisible = dlgConfig['extVisible'] === true;
        let showDlgFoot = dlgOkVisible || dlgCancelVisible || dlgExtVisible;
        //beforeCreate, created, beforeMount, mounted, beforeUpdate, updated, ..., beforeDestroy, destroyed
        //mounted, beforeDestroy
        let dlgLifecycle = dlgConfig['lifecycle'] || {};
        //
        let showDlgCloseBtn = dlgConfig['showCloseBtn'] || false;
        //
        let centerButtons = dlgConfig['centerButtons'] || false;
        //
        let closeOnClickShade = dlgConfig['closeOnClickShade'] === true;
        let closeOnPressEscape = dlgConfig['closeOnPressEscape'] === true;
        //
        let dlgCloseCallback = dlgConfig['onClosed'] || dlgConfig['closed'] || null;
        //
        dlgMethods['doOk'] = function () {
            let canClose = true;
            if (typeof dlgOkCallback == 'function') {
                canClose = dlgOkCallback.call(this, 'ok');
            }
            if (typeof canClose == 'undefined') {
                canClose = true;
            }
            return canClose;
        };

        dlgMethods['doCancel'] = function () {
            let canClose = true;
            if (typeof dlgCancelCallback == 'function') {
                canClose = dlgCancelCallback.call(this, 'cancel');
            }
            if (typeof canClose == 'undefined') {
                canClose = true;
            }
            return canClose;
        };

        dlgMethods['doExt'] = function () {
            let canClose = true;
            if (typeof dlgExtCallback == 'function') {
                canClose = dlgExtCallback.call(this, 'ext');
            }
            if (typeof canClose == 'undefined') {
                canClose = true;
            }
            return canClose;
        };
        //
        let DlgBody = {
            data: function () {
                return dlgData
            },
            template: dlgTemplate,
            methods: Utils.merge({
                get_dlg_root: function () {
                    let theElDlgWrapper = this.$parent.$el;
                    return $(theElDlgWrapper).find('>.el-dialog');
                },
                getDlgBodySize: function () {//公开方法
                    let theDlgRoot = this.get_dlg_root();
                    let theDlgBody = theDlgRoot.find('>.el-dialog__body');
                    let bodyWidth = $(theDlgBody).width();
                    let bodyHeight = $(theDlgBody).height();
                    //
                    return {
                        width: bodyWidth,
                        height: bodyHeight
                    };
                },
                tgr_bdy_size: function () {
                    if (this.dlgBodyResized) {//function (bodyWidth, bodyHeight)
                        let bodySize = this.getDlgBodySize();
                        this.dlgBodyResized.call(this, bodySize.width, bodySize.height);
                    }
                },
                trg_dlg_help: function () {
                    if (this.dlgContextHelp) {
                        this.dlgContextHelp.call(this);
                    }
                }
            }, dlgMethods),
            //
            created: function () {
                //触发自定义事件
                if (typeof dlgLifecycle['created'] == 'function') {
                    dlgLifecycle['created'].call(this);
                }
            },
            mounted: function () {
                let theDlgRoot = this.get_dlg_root();
                //大小、位置 调整前隐藏
                theDlgRoot.css('visibility', 'hidden');
                //v2.x
                theDlgRoot.css('position', 'absolute');
                //新增的默认的margin-top:15vh
                //theDlgRoot.css("margin-top", "0");
                //el-dialog 的top 属性（=> margin-top :）

                adjustJqDialogSize(theDlgRoot, {
                    width: dlgWidth,
                    height: dlgHeight
                }, showDlgTitle, showDlgFoot, centerButtons);
                //
                this.tgr_bdy_size();

                //触发自定义事件
                if (typeof dlgLifecycle['mounted'] == 'function') {
                    dlgLifecycle['mounted'].call(this);
                }
            },
            beforeDestroy: function () {
                //触发自定义事件
                if (typeof dlgLifecycle['beforeDestroy'] == 'function') {
                    dlgLifecycle['beforeDestroy'].call(this);
                }
            },
            destroyed: function () {
                //触发自定义事件
                if (typeof dlgLifecycle['destroyed'] == 'function') {
                    dlgLifecycle['destroyed'].call(this);
                }
            }
        };
        //
        let dlgDom = createDialogHolder();
        let dlgDomId = dlgDom.id;
        //
        let theVueDlg = new Vue({
            components: {
                'dlg-body': DlgBody
            },
            //
            el: '#' + dlgDomId,
            //
            data: {
                errid: errid,
                dlgTitle: dlgTitle,
                dlgSubTitle: dlgSubTitle,
                dlgVisible: true,
                showCloseBtn: showDlgCloseBtn,
                showTitle: showDlgTitle,
                //
                showFoot: showDlgFoot,
                //
                dlgOkText: dlgOkText,
                dlgCancelText: dlgCancelText,
                dlgExtText: dlgExtText,
                //
                dlgOkVisible: dlgOkVisible,
                dlgCancelVisible: dlgCancelVisible,
                dlgExtVisible: dlgExtVisible,
                dlgZIndex: zIndexManager.nextZIndex(),
                //
                closeOnClickModal: false, // closeOnClickShade, 有bug
                closeOnPressEscape: closeOnPressEscape,
                //
                showHelpIcon: showHelpIcon,
                //关闭原因
                closeReason: 'X'
            },
            //
            template: '<div name="dialog-holder" v-dialog-draggable>\
                        <el-dialog ref="the__dlg__elem" top="0" style="visibility: hidden;" :visible="dlgVisible" :z-index="dlgZIndex" :show-close="showCloseBtn" @close="close" :closeOnClickModal="closeOnClickModal" :closeOnPressEscape="closeOnPressEscape">\
                            <span v-if="showTitle" slot="title" class="dialog-t">{{dlgTitle}}<span v-if="dlgSubTitle != null" style="font-size:13px;"> - {{dlgSubTitle}}</span><span v-if="errid" title="错误ID" style="position:absolute;right:60px;cursor:default;color:orangered;font-size: 12px;">{{errid}}</span><span v-if="showHelpIcon" style="position:absolute;right:60px;cursor:pointer;color:gray;"><i title="帮助信息" class="el-icon-question" @click="toShowHelpInfo"></i></span></span>\
                            <dlg-body  ref="the__dlg__body"></dlg-body>\
                            <span v-if="showFoot" slot="footer" class="dialog-footer">\
                                <el-button :style="{display: dlgOkVisible ? \'\' : \'none\'}" type="primary" @click="doOk">{{dlgOkText}}</el-button>\
                                <el-button :style="{display: dlgCancelVisible ? \'\' : \'none\'}" @click="doCancel">{{dlgCancelText}}</el-button>\
                                <el-button :style="{display: dlgExtVisible ? \'\' : \'none\'}" @click="doExt">{{dlgExtText}}</el-button>\
                            </span>\
                        </el-dialog>\
                    </div>',
            //
            mounted: function () {
                //let dlgWrapper = $(this.$el).find('>.el-dialog__wrapper').get(0);
                //console.log('dialog-zIndex：' + dlgWrapper.style.zIndex);
            },
            beforeDestroy: function () {
                //销毁el-dialog
                this.$refs.the__dlg__elem.$destroy();
                //从dom树中移除自身
                this.$el.parentNode.removeChild(this.$el);
            },
            methods: {
                close: function () {
                    this.dlgVisible = false;
                    this.$destroy();
                    //
                    if (typeof dlgCloseCallback == 'function') {
                        dlgCloseCallback(this.closeReason);
                    }
                },

                doOk: function () {
                    if (this.$refs.the__dlg__body.doOk()) {
                        this.closeReason = 'ok';
                        this.close();
                    }
                },

                doCancel: function () {
                    if (this.$refs.the__dlg__body.doCancel()) {
                        this.closeReason = 'cancel';
                        this.close();
                    }
                },

                doExt: function () {
                    if (this.$refs.the__dlg__body.doExt()) {
                        this.closeReason = 'ext';
                        this.close();
                    }
                },

                toShowHelpInfo: function () {
                    this.$refs.the__dlg__body.trg_dlg_help();
                }
            }
        });

        //
        return {
            close: function () {
                theVueDlg.close();
                theVueDlg = null;
            },
            hide: function () {
                theVueDlg.close();
                theVueDlg = null;
            }
        };
    };

    //text, password, mltext
    //title, prompt, value, callback, type
    let showInputBox = function (options) {
        options = options || {};
        //
        let title = options['title'] || '请输入';
        let type = options['type'] || 'text';
        let width = options['width'] || 500;
        type = type.toLowerCase();
        let height = options['height'] || (type == 'mltext' ? 300 : 220);
        let prompt = options['prompt'] || '';
        let value = options['value'] || '';
        let callback = options['callback'];
        let minRows = options['minRows'] || 6;
        let maxRows = options['maxRows'] || 6;
        let autoSize = {
            minRows: minRows,
            maxRows: maxRows
        };
        let maxLength = options['maxLength'] || 250;
        //
        let dlgHandle = null;
        let config = {
            title: title,
            showTitle: true,
            width: width,
            height: height,
            showCloseBtn: false,
            template: '\
            <div>\
                <div v-if="prompt" style="margin-bottom:6px;color:gray;">{{prompt}}<span style="float:right;color:orange;font-size:12px;margin-top: 2px;">字符数限制：{{maxLength}}个</span></div>\
                <el-input v-if="type==\'mltext\'" type="textarea" style="width:100%;height:100%" v-model="value" :maxlength="maxLength" :autosize ="autoSize"></el-input>\
                <el-input v-else type="text" style="width:100%" v-model="value" :maxlength="maxLength"></el-input>\
            </div>\
            ',
            data: {
                prompt: prompt,
                type: type,
                value: value,
                autoSize: autoSize,
                maxLength: maxLength
            },
            okClicked: function () {
                if (Utils.isNoB(this.value)) {
                    if (typeof Toast != 'undefined' && Toast.show) {
                        Toast.show('请输入', 3000, 'warning');
                    }
                    return false;
                }
                //
                if (typeof callback == 'function') {
                    return callback(this.value, dlgHandle) !== false;
                } else {
                    console.info(this.value);
                    console.warn('没有指定 输入 回调 函数 ');
                    return true;
                }
            },
            cancelClicked: function () {
                return true;
            },
            //
            okVisible: true,
            cancelVisible: true,
            okText: '确 定',
            cancelText: '取消',
            centerButtons: true,
            //
            closeOnClickShade: false,
            closeOnPressEscape: true
        };
        //
        dlgHandle = showDialog(config);
        //
        return dlgHandle;
    };

    //
    let msgBoxTplHtml = '\
    <div class="msg-box {type}">\
        <i class="icon iconfont icon-{type} msg-icon"></i>\
        <p class="text">{message}</p>\
    </div>\
    ';

    //
    let autoClosableMsgBoxTypeMap = {
        'info': true,
        'success': true
    };

    let showMsgBox = function (type, message, options) {
        type = type || 'info';
        options = options || {};
        //
        let errid = null;
        if (type === 'error' || type === 'failure' || type === 'warning') {
            if (typeof options === 'string') {
                // string 的 options 当 errid
                options = {
                    'errid': options
                };
            }
            errid = options['errid'] || null;
            // 有错误id强制显示标题
            if (errid != null && !options['title']) {
                options['title'] = '提示';
            }
        } else {
            if (typeof options === 'string') {
                // string 的 options 当 title
                options = {
                    'title': options
                };
            }
        }
        //
        let title = options['title'] || '';
        let showTitle = title !== '';
        let width = options['width'] || 420;
        let height = options['height'] || (showTitle ? (type == 'loading' ? 160 : 220) : (type == 'loading' ? 120 : 170));
        let callback = options['callback'];
        let closeDelay = options['closeDelay'];
        let okVisible = options['okVisible'] !== false;
        //
        let callbackExecResult = null;
        //
        let closeCallback = function () {
            if (typeof callback === 'function') {
                callbackExecResult = callback() !== false;
            } else {
                callbackExecResult = true;
            }
            //
            return callbackExecResult;
        };
        //
        let config = {
            title: title,
            errid: errid,
            showTitle: showTitle,
            width: width,
            height: height,
            showCloseBtn: false,
            template: msgBoxTplHtml.format({
                type: type,
                message: message
            }),
            data: {},
            okClicked: closeCallback,
            cancelClicked: closeCallback,
            //
            okVisible: okVisible,
            cancelVisible: false,
            okText: '知道了',
            centerButtons: true,
            //
            closeOnClickShade: autoClosableMsgBoxTypeMap[type] === true,
            closeOnPressEscape: false
        };
        //
        let dlg = showDialog(config);
        //
        if (autoClosableMsgBoxTypeMap[type] === true) {
            if (typeof closeDelay == 'number' && closeDelay > 0) {
                let closeTimer = setTimeout(function () {
                        clearTimeout(closeTimer);
                        try {
                            if (callbackExecResult === true || closeCallback()) {
                                dlg.close();
                                //
                                dlg = null;
                            }
                        } catch (ex) {
                            console.error(ex);
                        }
                    },
                    closeDelay
                );
            }
        }
        //
        return dlg;
    };

    let lastMsgBoxDlg = null;
    let MessageBox = ELEMENT.MessageBox;
    let MsgBox = {
        show(type = 'info', msg, options) {
            if (type === 'loading') {
                msg = msg || '正在处理中，请稍后...';
                options = Utils.merge(options, {title: '', okVisible: false, closeOnClickShade: false, closeOnPressEscape: false});
            }
            lastMsgBoxDlg = showMsgBox(type, msg, options);
            return lastMsgBoxDlg;
        },
        info(msg, options) {
            lastMsgBoxDlg = showMsgBox('info', msg, options);
            return lastMsgBoxDlg;
        },
        warning(msg, options) {
            lastMsgBoxDlg = showMsgBox('warning', msg, options);
            return lastMsgBoxDlg;
        },
        error(msg, options) {
            lastMsgBoxDlg = showMsgBox('error', msg, options);
            return lastMsgBoxDlg;
        },
        success(msg, options) {
            lastMsgBoxDlg = showMsgBox('success', msg, options);
            return lastMsgBoxDlg;
        },
        failure(msg, options) {
            lastMsgBoxDlg = showMsgBox('failure', msg, options);
            return lastMsgBoxDlg;
        },
        loading(msg, options) {
            msg = msg || '正在处理中，请稍后...';
            options = Utils.merge(options, {title: '', okVisible: false, closeOnClickShade: false, closeOnPressEscape: false});
            lastMsgBoxDlg = showMsgBox('loading', msg, options);
            return lastMsgBoxDlg;
        },
        prompt(hint, callback, extra = {}) {
            let options = {};
            options.prompt = hint || null;
            options.callback = callback || null;
            if (typeof extra == 'string') {
                options.value = extra;
            } else {
                options = Utils.merge(options, extra);
            }
            return showInputBox(options);
        },
        confirm(msg, callback, extra = {}) {
            let title = extra['title'] || '确认提示';
            let confirmText = extra['confirmText'] || '确定';
            let cancelText = extra['cancelText'] || '取消';
            let iconType = extra['type'] || 'warning';
            let triggerAction = extra['action'] || 'confirm';//触发回调的action（confirm, cancel, all）
            //
            MessageBox.confirm(msg, title, {
                confirmButtonText: confirmText,
                cancelButtonText: cancelText,
                type: iconType,
                callback: function (action) {
                    if (triggerAction === 'all' || action === triggerAction) {
                        if (typeof callback === 'function') {
                            try {
                                callback(action);
                            } catch (ex) {
                                //
                            }
                        } else {
                            console.log('确认对话框 结果 : ' + action);
                        }
                    }
                }
            });
        }
    };

    //
    Vue.$showDialog = showDialog;
    Vue.$showMsgBox = showMsgBox;
    //
    //获取当前或指定实例的组件类定义信息
    function getClassInfo(instance) {
        instance = instance || this;
        return instance.$options;
    }

    //
    Vue.$getClassInfo = getClassInfo;

    //查询、结果配置存取单例对象
    let __queryResultConfStorer = null;

    //export
    function setQueryResultConfStorer(queryResultConfStorer) {
        __queryResultConfStorer = queryResultConfStorer || null;
        //注册到vue原型$confStorer
        Vue.prototype.$confStorer = __queryResultConfStorer;
    }

    //export
    function getQueryResultConfStorer() {
        return __queryResultConfStorer;
    }

    // 商户标签
    let __comnMerchantBizTag = null;

    //
    function setComnMerchantBizTag(comnMerchantBizTag) {
        __comnMerchantBizTag = comnMerchantBizTag || null;
        //注册到vue原型$comnBizTag
        Vue.prototype.$comnBizTag = __comnMerchantBizTag;
    }

    //
    function getComnMerchantBizTag() {
        return __comnMerchantBizTag;
    }

    // 附件标签
    let __comnMerchantAttTag = null;

    //
    function setComnMerchantAttTag(comnMerchantAttTag) {
        __comnMerchantAttTag = comnMerchantAttTag || null;
        //注册到vue原型$comnBizTag
        Vue.prototype.$comnBizTag = __comnMerchantAttTag;
    }

    //
    function getComnMerchantAttTag() {
        return __comnMerchantAttTag;
    }

    //页码选择对话框 resultCbk(ok?, range {from, to} )
    function showPageRangeSelDlg(title, totalPageCount /*总页码数*/, limitPageCount /*限制选择的页码数*/, lastPageNumber /*上次结束页码数*/, resultCbk /*回调函数*/, extra) {
        title = title || '选择范围';
        extra = extra || {};
        let pageAlias = extra.pageAlias || '文件' || '页码';
        let pageSize = extra.pageSize || 0;
        totalPageCount = totalPageCount || 0;
        limitPageCount = limitPageCount || 10;
        if (typeof lastPageNumber == 'function') {
            resultCbk = lastPageNumber;
            lastPageNumber = 0;
        } else {
            lastPageNumber = lastPageNumber || 0;
        }
        //
        if (totalPageCount < 1) {
            MsgBox.warning('总{0}数无效'.format(pageAlias));
            return;
        }
        if (lastPageNumber >= totalPageCount) {
            MsgBox.warning('已无{0}可以选择'.format(pageAlias));
            return;
        }
        let pageFrom = null;
        let pageTo = null;
        let pageCount = '??';
        if (lastPageNumber >= 0) {
            pageFrom = lastPageNumber + 1;
            pageTo = pageFrom + limitPageCount - 1;
            pageTo = Math.min(pageTo, totalPageCount);
            pageCount = pageTo - pageFrom + 1;
        }
        let subTitle = '总共 ' + totalPageCount + (' 个{0}，每次限制 '.format(pageAlias)) + limitPageCount + ' 个';
        if (pageSize > 0) {
            subTitle += '（每个{0}{1}条数据）'.format(pageAlias, pageSize);
        }
        let theDlg = showDialog({
            title: title,
            subTitle: subTitle,
            width: 500,//80%
            height: 180,//80%
            showCloseBtn: false,
            centerButtons: true,
            template: '\
                        <div style="color:#999;">\
                           <span style="display:inline-block;width:140px;color: navy;font-size:12px;margin-top: 6px;">已选 {{pageCount}} 个{{pageAlias}}</span>\
                           <span style="">从 <el-input style="width:60px;"  type="number" v-model="pageFrom" @change="checkValid(true, true)"></el-input> 到 <el-input style="width:60px;" type="number" v-model="pageTo" @change="checkValid(true, false)"></el-input></span>\
                        </div>\
                    ',
            data: {
                pageAlias: pageAlias,
                totalPageCount: totalPageCount,
                limitPageCount: limitPageCount,
                //
                pageFrom: pageFrom,
                pageTo: pageTo,
                pageCount: pageCount
            },
            methods: {
                checkValid(forFilter = false, isFrom = false) {
                    let valid = true;
                    let hintMsg = '';
                    let pageFrom = Utils.ParseInt(this.pageFrom);
                    this.pageFrom = pageFrom;
                    let pageTo = Utils.ParseInt(this.pageTo);
                    this.pageTo = pageTo;
                    if (forFilter) {
                        if (pageFrom != null && pageTo == null) {
                            if (isFrom) {
                                this.pageTo = pageTo = Math.min(this.totalPageCount, pageFrom + this.limitPageCount - 1);
                            }
                        }
                        if (pageFrom != null && pageTo != null) {
                            let pageToTmp = pageFrom + this.limitPageCount - 1;
                            if (pageToTmp < pageTo) {
                                this.pageTo = pageTo = pageToTmp;
                                //
                                this.$message({
                                    type: 'info',
                                    message: ('截止{0}序号已自动限制调整到第 ' + pageToTmp + ' 个').format(this.pageAlias)
                                });
                            }
                            this.pageCount = pageTo - pageFrom + 1;
                        }
                    } else {
                        if (pageFrom == null || pageTo == null || pageFrom < 1 || pageTo > this.totalPageCount) {
                            valid = false;
                            hintMsg = ('{0}序号范围必须是 正整数 且 在 1 - ' + this.totalPageCount + ' 之间').format(this.pageAlias);
                            this.pageCount = '??';
                        } else if (pageFrom > pageTo) {
                            valid = false;
                            hintMsg = ('截止{0}序号 必须 大于或等于 起始{0}序号').format(this.pageAlias);
                            this.pageCount = '??';
                        }

                        if (!valid && !forFilter) {
                            this.$message({
                                type: 'warning',
                                message: hintMsg
                            });
                        }
                    }
                    return valid;
                }
            },
            okClicked: function () {
                if (this.checkValid()) {
                    let result = {
                        from: Utils.ParseInt(this.pageFrom),
                        to: Utils.ParseInt(this.pageTo)
                    };
                    //
                    theDlg.close();
                    //
                    if (resultCbk) {
                        resultCbk(true, result);
                    }
                } else {
                    return false;
                }
            },
            cancelClicked: function () {
                theDlg.close();
                //
                if (resultCbk) {
                    resultCbk(false);
                }
            }
        });
    }

    /**  虚拟行id工具类，解决 el-table + form 行定位 和 输入 问题 */
    function VRowId() {
        let _xxId = 0;
        let _name = '_vid';
        let _prefix = null;
        let _childrenProp = 'children';
        //
        this.init = function (initNum) {
            if (typeof initNum == 'number') {
                initNum = Utils.ParseInt(initNum);
                if (initNum != null) {
                    _xxId = initNum;
                }
            } else {
                console.warn('initNum 必须为整数');
            }
        };
        //
        this.name = function (name, prefix) {
            if (arguments.length == 0) {
                return _name;
            } else {
                _name = name || _name;
                _prefix = prefix || null;
                //
                return this;
            }
        };
        //
        this.childrenProp = function (propName) {
            _childrenProp = propName || 'children';
        }
        //
        this.newId = function () {
            let numId = ++_xxId;
            return _prefix ? _prefix + '' + numId : numId;
        };

        //
        this.setId = function (row, reset = false) {
            if (row != null) {
                if (row[_name] == null || reset) {
                    row[_name] = this.newId();
                }
            }
            //
            return this;
        };

        //
        this.delId = function (row) {
            if (row != null) {
                if (row[_name] != null) {
                    delete row[_name];
                }
            }
            //
            return this;
        };

        this._setIds_inner = function (rows, reset, forTree) {
            rows = rows || [];
            reset = reset === true;
            forTree = forTree === true;
            //
            let row = null, children = null;
            for (let i = 0, c = rows.length; i < c; i++) {
                row = rows[i];
                if (row != null) {
                    if (row[_name] == null || reset) {
                        row[_name] = this.newId();
                    }
                    //
                    if (forTree && ((children = row[_childrenProp]) != null)) {
                        this._setIdsInner(children, reset, forTree);
                    }
                }
            }
        };

        this.setIds = function (rows, reset = false) {
            this._setIds_inner(rows, reset, false);
            //
            return this;
        };
        this.setTreeIds = function (rows, reset = false) {
            this._setIdsInner(rows, reset, true);
            //
            return this;
        };

        this._delIds_inner = function (rows, forTree) {
            rows = rows || [];
            forTree = forTree === true;
            let row = null, children = null;
            for (let i = 0, c = rows.length; i < c; i++) {
                row = rows[i];
                if (row != null) {
                    if (row[_name] != null) {
                        delete row[_name];
                    }
                    //
                    if (forTree && ((children = row[_childrenProp]) != null)) {
                        this._delIds_inner(children, forTree);
                    }
                }
            }
        };

        this.delIds = function (rows) {
            this._delIds_inner(rows, false);
            //
            return this;
        };
        this.delTreeIds = function (rows) {
            this._delIds_inner(rows, true);
            //
            return this;
        };

    }

    VRowId.newOne = function () {
        return new VRowId();
    };

    /**
     * 从数据列表中找到指定的关键值对应的数据项
     * @param dataItems 数据条目列表
     * @param keyVal 关键值
     * @param keyProp 关键属性名（默认：'id'）
     * @param childrenProp 子项属性名（默认：'children'）
     * @returns { {} }
     */
    function findDataItemByItemKey(dataItems, keyVal, keyProp, childrenProp) {
        dataItems = dataItems || [];
        keyProp = keyProp || 'id';
        childrenProp = childrenProp || 'children';
        let tempItem = null, children = null;
        for (let i = 0, c = dataItems.length; i < c; i++) {
            tempItem = dataItems[i];
            if (tempItem[keyProp] == keyVal) {
                return tempItem;
            } else {
                children = tempItem[childrenProp] || null;
                if (children != null && children.length > 0) {
                    let retItem = findDataItemByItemKey(children, keyVal, keyProp, childrenProp);
                    if (retItem != null) {
                        return retItem;
                    }
                }
            }
        }
        //
        return null;
    }

    //-------------------------------------------------------------------------------------

    /**
     * 汇总数据项（中指定属性）的值
     * @param dataItems 数据条目列表
     * @param propNames 要汇总的属性名列表 ['pro1', 'prop2']
     * @param valMapper 属性值 valMapper(dataRow, propNames, subValMap) => {'prop1' : val1, 'prop2' : val2 }
     * @param childrenProp 子项属性名（默认：children）
     * @returns { {'prop1' : val1, 'prop2' : val2 } }
     */
    function sumCommonItems(dataItems, propNames, valMapper, childrenProp) {
        dataItems = dataItems || [];
        propNames = propNames || [];
        childrenProp = childrenProp || 'children';
        let valMap = {};
        let propCount = propNames == null ? 0 : propNames.length;
        let itemCount = dataItems.length;
        if (propCount < 1 || itemCount < 1) {
            return valMap;
        }
        //初始化值映射
        let propName;
        for (let k = 0; k < propCount; k++) {
            propName = propNames[k];
            valMap[propName] = 0;
        }
        //
        let tempItem, tempMap, children, subMap;
        for (let i = 0; i < itemCount; i++) {
            tempItem = dataItems[i];
            if (tempItem != null) {
                //先计算明细子项的汇总值
                children = tempItem[childrenProp] || null;
                if (children != null && children.length > 0) {
                    subMap = sumCommonItems(children, propNames, valMapper, childrenProp);
                } else {
                    subMap = null;
                }
                //根据当前项和子项汇总值决定最终汇总值
                if (valMapper != null) {//自定义取舍逻辑
                    tempMap = valMapper(tempItem, propNames, subMap) || null;
                } else {//默认取舍逻辑
                    tempMap = {};
                    if (subMap == null) {
                        subMap = {}; //此处仅仅为了方便判断和计算
                    }
                    //子项汇总值优先
                    for (let k = 0; k < propCount; k++) {
                        propName = propNames[k];
                        tempMap[propName] = subMap[propName] == null ? (Utils.ParseFloat(tempItem[propName]) || 0) : (Utils.ParseFloat(subMap[propName]) || 0);
                    }
                }
                if (tempMap != null) {
                    //汇总属性值
                    for (let k = 0; k < propCount; k++) {
                        propName = propNames[k];
                        valMap[propName] += Utils.ParseFloat(tempMap[propName]) || 0;
                    }
                }
            }
        }
        return valMap;
    }

    //-------------------------------------------------------------------------------------
    function _sumDetailItems_inner(dataItems, propNames, valMap, valMapper, childrenProp) {
        childrenProp = childrenProp || 'children';
        let tempItem, children, tempMap, propName;
        let propCount = propNames == null ? 0 : propNames.length;
        for (let i = 0, c = dataItems.length; i < c; i++) {
            tempItem = dataItems[i];
            if (tempItem != null) {
                children = tempItem[childrenProp] || null;
                if (children != null && children.length > 0) {
                    _sumDetailItems_inner(children, propNames, valMap, valMapper, childrenProp);
                } else {
                    if (valMapper != null) {//自定义汇总值
                        tempMap = valMapper(tempItem, propNames) || null;
                    } else {//默认汇总值
                        tempMap = {};
                        for (let k = 0; k < propCount; k++) {
                            propName = propNames[k];
                            tempMap[propName] = Utils.ParseFloat(tempItem[propName]) || 0;
                        }
                    }
                    if (tempMap != null) {
                        //汇总属性值
                        for (let k = 0; k < propCount; k++) {
                            propName = propNames[k];
                            valMap[propName] += Utils.ParseFloat(tempMap[propName]) || 0;
                        }
                    }
                }
            }
        }
    }

    /**
     * 汇总明细项（中指定属性）的值
     * @param dataItems 数据条目列表
     * @param propNames 要汇总的属性名列表 ['pro1', 'prop2']
     * @param valMapper 属性值 valMapper(dataRow, propNames) => {'prop1' : val1, 'prop2' : val2 }
     * @param childrenProp 子项属性名（默认：children）
     * @returns { {'prop1' : val1, 'prop2' : val2 } }
     */
    function sumDetailItems(dataItems, propNames, valMapper, childrenProp) {
        dataItems = dataItems || [];
        propNames = propNames || [];
        childrenProp = childrenProp || 'children';
        let valMap = {};
        let propCount = propNames == null ? 0 : propNames.length;
        let itemCount = dataItems.length;
        if (propCount < 1 || itemCount < 1) {
            return valMap;
        }
        //初始化值映射
        let propName;
        for (let k = 0; k < propCount; k++) {
            propName = propNames[k];
            valMap[propName] = 0;
        }
        _sumDetailItems_inner(dataItems, propNames, valMap, valMapper, childrenProp);
        return valMap;
    }

    //dependNodeMap 依赖关系 { srcNode => [destNode1, destNode2, ...] }
    //结果，影响的 { destNode => [srcNode1, srcNode2, ...] }
    function toDependedNodeMap(dependNodeMap) {
        dependNodeMap = dependNodeMap || {};
        let returnMap = {};
        let destNodes = null;
        let tempNodes = null;
        let destNode = null;
        for (let srcNode in dependNodeMap) {
            destNodes = dependNodeMap[srcNode] || [];
            if (typeof destNodes == 'string') { //, 分割 的
                tempNodes = destNodes.split(',', -1);
                destNodes = [];
                for (let j = 0, jc = tempNodes.length; j < jc; j++) {
                    destNodes.push(tempNodes[j]);
                }
            }
            if (Utils.isArray(destNodes) && destNodes.length > 0) {
                for (let j = 0, jc = destNodes.length; j < jc; j++) {
                    destNode = destNodes[j].trim();
                    if (destNode == '' || destNode == srcNode) {
                        continue;
                    }
                    tempNodes = returnMap[destNode];
                    if (tempNodes == null) {
                        tempNodes = returnMap[destNode] = [];
                    }
                    if (tempNodes.indexOf(srcNode) == -1) {
                        tempNodes.push(srcNode);
                    }
                }
            }
        }
        return returnMap;
    }

    let getDomElStyle = Utils.getDomElStyle;

    /** 计算限定大小下dom未来的核心内容区宽度、高度像素数 */
    function calcDomFutureCoreSize(jqDom, totalWidth, totalHeight) {
        let elDom = jqDom.get(0);
        let coreWidth = totalWidth || 0;
        let coreHeight = totalHeight || 0;
        let style = getDomElStyle(elDom);
        if (style) {
            let tmpNum = null;
            //width
            tmpNum = style.paddingLeft;
            if (tmpNum) {
                coreWidth -= parseInt(tmpNum);
            }
            tmpNum = style.paddingRight;
            if (tmpNum) {
                coreWidth -= parseInt(tmpNum);
            }

            tmpNum = style.borderLeftWidth;
            if (tmpNum) {
                coreWidth -= parseInt(tmpNum);
            }
            tmpNum = style.borderRightWidth;
            if (tmpNum) {
                coreWidth -= parseInt(tmpNum);
            }

            tmpNum = style.marginLeft;
            if (tmpNum) {
                coreWidth -= parseInt(tmpNum);
            }
            tmpNum = style.marginRight;
            if (tmpNum) {
                coreWidth -= parseInt(tmpNum);
            }
            //height
            tmpNum = style.paddingTop;
            if (tmpNum) {
                coreHeight -= parseInt(tmpNum);
            }
            tmpNum = style.paddingBottom;
            if (tmpNum) {
                coreHeight -= parseInt(tmpNum);
            }

            tmpNum = style.borderTopWidth;
            if (tmpNum) {
                coreHeight -= parseInt(tmpNum);
            }
            tmpNum = style.borderBottomWidth;
            if (tmpNum) {
                coreHeight -= parseInt(tmpNum);
            }

            tmpNum = style.marginTop;
            if (tmpNum) {
                coreHeight -= parseInt(tmpNum);
            }
            tmpNum = style.marginBottom;
            if (tmpNum) {
                coreHeight -= parseInt(tmpNum);
            }
        }
        return {
            width: coreWidth,
            height: coreHeight
        };
    }

    //计算占用的（带margin）像素宽度
    function calcDomWidth(jqDom, margin) {
        if (jqDom == null || jqDom.length < 1) {
            return 0;
        }
        margin = margin != false;
        //
        let width = jqDom.width();
        let elDom = jqDom.get(0);
        if (elDom.offsetWidth != null) {
            width = elDom.offsetWidth;
        }
        if (margin) {
            let style = getDomElStyle(elDom);
            if (style) {
                let tmpNum = null;
                tmpNum = style.marginLeft;
                if (tmpNum) {
                    width += parseInt(tmpNum);
                }
                tmpNum = style.marginRight;
                if (tmpNum) {
                    width += parseInt(tmpNum);
                }
            }
        }
        //
        return width;
    }

    //计算占用的（带margin）像素高度
    function calcDomHeight(jqDom, margin) {
        if (jqDom == null || jqDom.length < 1) {
            return 0;
        }
        margin = margin != false;
        //
        let height = jqDom.height();
        let elDom = jqDom.get(0);
        if (elDom.offsetHeight != null) {
            height = elDom.offsetHeight;
        }
        if (margin) {
            let style = getDomElStyle(elDom);
            if (style) {
                let tmpNum = null;
                tmpNum = style.marginTop;
                if (tmpNum) {
                    height += parseInt(tmpNum);
                }
                tmpNum = style.marginBottom;
                if (tmpNum) {
                    height += parseInt(tmpNum);
                }
            }
        }
        //
        return height;
    }

    //获取el-table实际所需高度
    function getElTableHeight(vueTable) {
        if (vueTable == null) {
            return 0;
        }
        let jqTable = $(vueTable.$el || vueTable);
        //head wrapper
        let jqDomHeadWrapper = jqTable.find('>.el-table__header-wrapper');
        let headHeight = jqDomHeadWrapper.height() || 0;
        //body wrapper
        let jqDomBodyWrapper = jqTable.find('>.el-table__body-wrapper');
        //body parts
        let jqDomBodyParts = jqDomBodyWrapper.find('>table, >div');
        let bodyHeight = 0;
        jqDomBodyParts.each(function (index, tblDom) {
            bodyHeight += $(tblDom).height();
        });
        //ignore fixed
        let totalHeight = headHeight + bodyHeight;
        console.log('el-table need height : ' + totalHeight);
        //
        return totalHeight;
    }

    //调整eltable固定部分的高度（如果无滚动条+17）
    function fixElTableFixedHeight(vueTable) {
        if (vueTable == null) {
            return 0;
        }
        let jqTable = $(vueTable.$el || vueTable);
        //
        let jqDomFixedWrapper = jqTable.find('>.el-table__fixed, >el-table__fixed-right');
        if (jqDomFixedWrapper.length > 0) {
            //head wrapper
            let jqDomHeadWrapper = jqTable.find('>.el-table__header-wrapper');
            let headHeight = jqDomHeadWrapper.height() || 0;
            //body wrapper
            let jqDomBodyWrapper = jqTable.find('>.el-table__body-wrapper');
            let bodyHeight = jqDomBodyWrapper.height() || 0;
            //
            let hasHrScrollBar = jqTable.hasClass('el-table--scrollable-x');
            let fixedBodyHeight = hasHrScrollBar ? bodyHeight - 17 : bodyHeight;
            let fixedTotalHeight = headHeight + fixedBodyHeight;
            jqDomFixedWrapper.each(function (idx, wrapper) {
                wrapper = $(wrapper);
                wrapper.height(fixedTotalHeight);
                let fixedBody = wrapper.find('>.el-table__fixed-body-wrapper');
                fixedBody.css('top', headHeight + 'px');
                fixedBody.css('height', fixedBodyHeight + 'px');
            });
        }
    }

    //页面主(Main)尺寸大小监视器
    function DomSizeWatcher(tagName) {
        var tagName = tagName || '未命名';
        var sizeDelayer = null;
        //
        var bseDom = $(window);
        var bseDomWidth = 0;
        var bseDomHeight = 0;
        var bseDomSizeListener = null;
        //
        var hrDoms = [];
        var hrFixedWidth = 0;
        var hrDomsWidth = 0;
        //
        var vtDoms = [];
        var vtFixedHeight = 0;
        var vtDomsHeight = 0;
        //
        var theDom = null;
        var theDomWidth = 0;
        var theDomHeight = 0;
        var theDomSizeListener = null;
        //是否自动调整主元素
        var theDomAutoAdjusted = true;

        //
        var running = false;
        var runTimer = null;
        var runInterval = 300;

        var calcLayout = function () {
            if (!running) {
                return;
            }
            //
            let sizeChanged = false;
            //
            let baseWidth = bseDom.width();//内容区宽度
            let baseHeight = bseDom.height();//内容区高度
            if (baseWidth != bseDomWidth || baseHeight != bseDomHeight) {
                sizeChanged = true;
            }
            bseDomWidth = baseWidth;
            bseDomHeight = baseHeight;

            let tempDom = null;

            let otherHrWidth = hrFixedWidth;
            for (let i = 0, c = hrDoms.length; i < c; i++) {
                tempDom = hrDoms[i];
                otherHrWidth += calcDomWidth(tempDom);
            }
            if (otherHrWidth != hrDomsWidth) {
                sizeChanged = true;
            }
            hrDomsWidth = otherHrWidth;

            let otherVtHeight = vtFixedHeight;
            for (let i = 0, c = vtDoms.length; i < c; i++) {
                tempDom = vtDoms[i];
                otherVtHeight += calcDomHeight(tempDom);
            }
            if (otherVtHeight != vtDomsHeight) {
                sizeChanged = true;
            }
            vtDomsHeight = otherVtHeight;

            if (sizeChanged) {
                console.group(tagName);
                console.log('base : ' + bseDomWidth + ' x ' + bseDomHeight);
                console.log('other width : ' + hrDomsWidth);
                console.log('other height : ' + vtDomsHeight);
                //
                theDomWidth = baseWidth - hrDomsWidth;
                theDomHeight = baseHeight - vtDomsHeight;

                let newWidth = theDomWidth;
                let newHeight = theDomHeight;
                let theDomExist = theDom != null && theDom.length > 0;
                if (theDomExist) {
                    console.log('old size : ' + theDom.width() + ' , ' + theDom.height());
                    let newSize = calcDomFutureCoreSize(theDom, newWidth, newHeight);
                    newWidth = newSize.width;
                    newHeight = newSize.height;

                    if (theDomAutoAdjusted) {
                        theDom.width(newWidth);
                        theDom.height(newHeight);
                    }
                }
                //
                let theName = theDomExist ? (theDom.attr('name') || theDom.get(0).className || '') : '';
                theName = theName || '主元素';
                console.log(tagName + '.' + theName + ' => ' + newWidth + ' x ' + newHeight);
                //通知
                if (theDomSizeListener) {
                    let tmpDom = theDomExist ? theDom : null;
                    try {
                        theDomSizeListener.call(null, newWidth, newHeight, tmpDom);
                    } catch (ex) {
                        console.error(ex);
                    }
                }
                console.groupEnd();
            }
            //
            runTimer = setTimeout(calcLayout, runInterval);
        };

        /** 设置基准父元素（可以是jquery/css3选择器字符串，原生dom元素）*/
        this.setBaseEl = function (baseEl) {
            if (baseEl == null) {
                baseEl = window;
            }
            baseEl = $(baseEl);
            if (baseEl.length == 1) {
                bseDomWidth = 0;
                bseDomHeight = 0;

                if (bseDom != null && bseDomSizeListener != null) {//解绑旧的
                    bseDom.unbind('resize', bseDomSizeListener);
                }
                bseDom = baseEl;
            } else {
                console.error(tagName + ' 指定的基准元素不存在 或 不唯一');
            }
        };
        /** 设置水平方向指定元素外的固定部分宽度（带margin） */
        this.setHrFixedWidth = function (fixedWidth) {
            hrFixedWidth = fixedWidth || 0;
        };
        /** 设置水平方向的元素（可以是jquery/css3选择器字符串，原生dom元素，可变参数） */
        this.setHrEls = function () {
            let args = arguments;

            hrDoms = [];
            hrDomsWidth = 0;

            let tmpEls = null, tmpEl = null;
            for (let i = 0, c = args.length; i < c; i++) {
                tmpEls = args[i];
                if (tmpEls) {
                    tmpEls = $(tmpEls);
                    if (tmpEls.length > 0) {
                        for (let j = 0, cc = tmpEls.length; j < cc; j++) {
                            tmpEl = $(tmpEls.get(j));
                            hrDoms.push(tmpEl);
                        }
                    }
                }
            }
        };
        /** 设置垂直方向指定元素外固定部分高度（带margin） */
        this.setVtFixedHeight = function (fixedHeight) {
            vtFixedHeight = fixedHeight || 0;
        };
        /** 设置垂直方向的元素（可以是jquery/css3选择器字符串，原生dom元素，可变参数） */
        this.setVtEls = function () {
            let args = arguments;

            vtDoms = [];
            vtDomsHeight = 0;

            let tmpEls = null, tmpEl = null;
            for (let i = 0, c = args.length; i < c; i++) {
                tmpEls = args[i];
                if (tmpEls) {
                    tmpEls = $(tmpEls);
                    if (tmpEls.length > 0) {
                        for (let j = 0, cc = tmpEls.length; j < cc; j++) {
                            tmpEl = $(tmpEls.get(j));
                            vtDoms.push(tmpEl);
                        }
                    }
                }
            }
        };
        /** 设置主体元素（非必须，可以是jquery/css3选择器字符串，原生dom元素）和事件处理器，参数：width, height, jqDom） */
        this.setMainEl = function (mainEl, sizeListener) {
            if (typeof mainEl == 'function') {
                sizeListener = mainEl;
                mainEl = null;
            }
            theDom = null;
            theDomSizeListener = null;
            if (mainEl != null) {
                mainEl = $(mainEl);
                if (mainEl.length == 1) {
                    theDom = mainEl;
                } else {
                    console.error(tagName + ' 指定的 主体元素 不存在 或 不唯一');
                }
            } else {
                console.warn('未指定主体元素，将把剩余大小作为 未知主体元素 的大小');
            }
            if (typeof sizeListener == 'function') {
                theDomSizeListener = sizeListener;
            }
        };
        this.getMainEl = function () {
            return theDom;
        };
        //
        this.start = function (interval, adjustMainElSize) {
            if (typeof interval == 'boolean') {
                adjustMainElSize = interval;
                interval = 300;
            } else {
                interval = interval || 300;
            }
            runInterval = interval;
            theDomAutoAdjusted = adjustMainElSize !== false;
            //
            if (running) {
                console.warn(tagName + ' 已启动过了');
                return;
            }
            running = true;

            sizeDelayer = new Utils.TaskDelayer();
            bseDomSizeListener = function () {
                clearTimeout(runTimer);
                console.debug('基准对象 resized');
                sizeDelayer.delay(calcLayout, runInterval);
            };
            bseDom.bind('resize', bseDomSizeListener);
            //
            bseDomWidth = 0;
            bseDomHeight = 0;

            hrDomsWidth = 0;
            vtDomsHeight = 0;

            theDomWidth = 0;
            theDomHeight = 0;
            //
            runTimer = setTimeout(calcLayout, runInterval);
        };
        //
        this.stop = function () {
            if (running) {
                running = false;

                clearTimeout(runTimer);
                sizeDelayer.cancel();
                bseDom && bseDom.unbind('resize', bseDomSizeListener);
            }
        };
        //
        this.clear = function () {
            this.stop();
            //
            sizeDelayer = null;
            theDom = null;
            theDomSizeListener = null;
            hrDoms = vtDoms = [];
            bseDom = null;
            bseDomSizeListener = null;
        };
    }

    /** 获取当前内容区的宽、高 */
    function getContentAreaSize() {
        let jqEl = $('.page-wrap > .main-wrap > .content-area');
        if (jqEl != null && jqEl.length == 1) {
            return {
                width: jqEl.width(),
                height: jqEl.height()
            }
        }
        return null;
    }

    /** 获取列定义的默认格式化字符串 */
    function getColDefFormat(colConf) {
        let dataType = colConf.dataType;
        let format = null;
        if (dataType == 'float') {
            format = '0.00';
            if (colConf.percent) {
                format += '%';
            }
        } else if (dataType == 'integer') {
            if (colConf.percent) {
                format = '0%';
            }
        } else if (dataType == 'date') {
            let sqlType = colConf.sqlType || '';
            if (sqlType == 'DATE') {
                format = 'yyyy-MM-dd';
            } else if (sqlType == 'TIME') {
                format = 'HH:mm:ss';
            } else if (sqlType.indexOf('DATETIME') == 0 || sqlType.indexOf('TIMESTAMP') == 0) {
                format = 'yyyy-MM-dd HH:mm:ss';
            }
        } else if (dataType == 'bool') {
            format = '是/否';
        }
        return format;
    }

    /** 获取列定义的默认数据类型的对齐方式 */
    function getColDefAlign(colConf) {
        let dataType = typeof colConf == 'string' ? colConf : colConf.dataType;
        let align = 'left';
        if (dataType == 'integer' || dataType == 'float') {
            align = 'right';
        } else if (dataType == 'date' || dataType == 'bool') {
            align = 'center';
        }
        //
        return align;
    }

    //简单java类型
    function getSimpleJavaTypes(forCustomize) {
        if (forCustomize === true) {//只获取可定制化的部分
            return ['String', 'Integer', 'Long', 'Float', 'Double', 'Date', 'Boolean'];
        } else {
            return ['String', 'Integer', 'Long', 'Float', 'Double', 'Date', 'Boolean', 'BigDecimal', 'Short', 'Character'];
        }
    }

    //简单java类型name => text
    function getSimpleJavaTypesMap() {
        return {
            'String': '字符串',
            'Integer': '整数(32bit)',
            'Long': '整数(64bit)',
            'Float': '单精浮点数',
            'Double': '双精浮点数',
            'Date': '简单日期',
            'Boolean': '布尔（是否）',
            //
            'BigDecimal': '金额数值',
            'Short': '整数(16bit)',
            'Character': '单个字符'
        };
    }

    //字符类类型
    let __str_alike_type_names = ['String', 'Character'];

    function isStrAlikeType(typeName) {
        return __str_alike_type_names.indexOf(typeName) != -1;
    }

    //整数类类型
    let __int_alike_type_names = ['Integer', 'Long', 'Short', 'Byte'];

    function isIntAlikeType(typeName) {
        return __int_alike_type_names.indexOf(typeName) != -1;
    }

    //浮点类类型
    let __float_alike_type_names = ['Float', 'Double', 'BigDecimal'];

    function isFloatAlikeType(typeName) {
        return __float_alike_type_names.indexOf(typeName) != -1;
    }

    function convertToTypedValue(strVal, typeName) {
        if (isIntAlikeType(typeName)) {
            strVal = strVal == null ? null : strVal + '';
            if (strVal != null) {
                return Utils.ParseInt(strVal);
            }
        } else if (isFloatAlikeType(typeName)) {
            strVal = strVal == null ? null : strVal + '';
            if (strVal != null) {
                return Utils.ParseFloat(strVal);
            }
        } else if (typeName == 'Boolean') {
            strVal = strVal == null ? null : strVal + '';
            if (strVal != null) {
                strVal = strVal.toLowerCase();
                if (strVal == 'true') {
                    return true;
                } else if (strVal == 'false') {
                    return false;
                }
            }
        } else if (typeName == 'Date') {
            strVal = strVal == null ? null : strVal;
            if (strVal != null) {
                if (strVal instanceof Date) {
                    let theVal = strVal;
                    return theVal.isValid() ? theVal : null;
                } else {
                    let theVal = Date.parseAsDate(strVal + '');
                    return theVal == null ? null : (theVal.isValid() ? theVal : null);
                }
            }
        } else if (typeName == 'Character') {
            strVal = strVal == null ? null : strVal + '';
            if (strVal.length > 0) {
                return strVal.charAt(0);
            }
        } else {//String
            strVal = strVal == null ? null : strVal + '';
            return strVal;
        }

        return null;
    }

    function convertToTypedStr(strVal, typeName) {
        let value = convertToTypedValue(strVal, typeName);
        if (typeName == 'Date') {
            if (value instanceof Date) {
                return value.isValid() ? value.format('yyyy-MM-dd') : null;
            }
        } else if (isFloatAlikeType(typeName)) {
            if (typeof value == 'number') {
                return value.round(2) + '';
            }
        }
        return value == null ? null : value + '';
    }

    //基本输入类型
    function getInputTypes() {
        return [{
            text: '单行文本',
            name: 'Text',
            valueTypes: ['String']
        }, {
            text: '多行文本',
            name: 'MlText',
            valueTypes: ['String']
        }, {
            text: '数值',
            name: 'Num',
            valueTypes: ['Integer', 'Long', 'Float', 'Double']
        }, {
            text: '布尔',
            name: 'Bool',
            valueTypes: ['Boolean']
        }, {
            text: '日期',
            name: 'Date',
            valueTypes: ['Date', 'String']
        }, {
            text: '单选',
            name: 'Single',
            valueTypes: ['Integer', 'String']
        }, {
            text: '多选',
            name: 'Multi',
            valueTypes: ['Integer', 'String']
        }];
    }

    //
    let __def_java_input_type_map = {
        'String': 'Text',
        'Integer': 'Num',
        'Long': 'Num',
        'Float': 'Num',
        'Double': 'Num',
        'Boolean': 'Bool',
        'Date': 'Date'
    };

    //默认的java类型对应的输入类型
    function getDefInputTypeNameFor(javaTypeName) {
        return __def_java_input_type_map[javaTypeName];
    }

    /* 显示二维码对话框（content 可以是任何文本内容）*/
    function showQrCodeImageDlg(content, title, width = 200, height = 200, appBaseUrl, attachInfo) {
        if (appBaseUrl && Utils.isPlainObject(appBaseUrl)) {//attachInfo 放在了 appBaseUrl的位置上
            attachInfo = appBaseUrl;
            appBaseUrl = null;
        }
        //
        let dlgWidth = width + 100;
        let dlgHeight = height + 100;
        //
        if (attachInfo) {//根据附加信息调整对话框高度
            let headText = attachInfo['headText'];
            if (headText) {
                let headHeight = attachInfo['headHeight'] || 26;
                dlgHeight += headHeight;
            }
            let footText = attachInfo['footText'];
            if (footText) {
                let footHeight = attachInfo['footHeight'] || 24;
                dlgHeight += footHeight;
            }
        }
        //
        let qrCodeImageUrl = appConf.makeQrCodeImageUrl(content, width, height, appBaseUrl, attachInfo);
        let dlgTitle = title == null ? '二维码' : title;
        //
        showDialog({
            title: dlgTitle,
            width: dlgWidth,
            height: dlgHeight,
            //showTitle : false,
            showCloseBtn: true,
            okText: '关 闭',
            okVisible: false,
            cancelVisible: false,
            centerButtons: true,
            closeOnClickShade: true,
            template: '<center ><img style="text-align: center" v-bind:style="{ \'min-width\': imageWidth + \'px\', \'min-height\': imageHeight + \'px\'}" :src="imageUrl" /></center>',
            data: {
                // imageHint: content,
                imageWidth: width,
                imageHeight: height,
                imageUrl: qrCodeImageUrl
            }
        });
    }

    // -------------------------------------------------------------------------------------------

    //TODO 暂时存放 childrenColumnName（"子节点"） showChildren
    function filterByName(menu, name, childrenColumnName, showChildren, nodeKeys, nodeKeyColumnName, nodeSearchColumnNames) {
        childrenColumnName = childrenColumnName == null ? 'children' : childrenColumnName;
        showChildren = showChildren == null ? false : showChildren;
        nodeKeyColumnName = nodeKeyColumnName == null ? 'nodeKey' : nodeKeyColumnName;
        nodeKeys = nodeKeys == null ? [] : nodeKeys;
        nodeSearchColumnNames = nodeSearchColumnNames == null ? ['name'] : nodeSearchColumnNames;
        //
        let menuNew = [];
        for (let i = 0; i < menu.length; i++) {
            let nodeNew = undefined;
            let node = menu[i];
            let childrenNode = node[childrenColumnName];
            //
            let childrenMenu = [];
            if (!Utils.isNoB(childrenNode) && childrenNode.length > 0) {
                childrenMenu = filterByName(childrenNode, name, childrenColumnName, showChildren, nodeKeys, nodeKeyColumnName, nodeSearchColumnNames);
            }
            if (childrenMenu.length > 0) {
                nodeNew = {};
                nodeNew = nodeFillNewFromOld(childrenColumnName, node, nodeNew);
                nodeNew[childrenColumnName] = childrenMenu;
                nodeKeys.push(node[nodeKeyColumnName]);
            } else {
                for (let j = 0; j < nodeSearchColumnNames.length; j++) {
                    let columnName = nodeSearchColumnNames[j];
                    if (!Utils.isNoB(node[columnName]) && ((typeof node[columnName] == 'string' && node[columnName].indexOf(name) != -1) || node[columnName] == name)) {
                        nodeNew = {};
                        nodeKeys.push(node[nodeKeyColumnName]);
                        if (showChildren) {
                            nodeNew = node;
                        } else {
                            nodeNew = nodeFillNewFromOld(childrenColumnName, node, nodeNew);
                        }
                    }
                }
            }
            if (!Utils.isNoB(nodeNew)) {
                menuNew.push(nodeNew);
            }
        }
        return menuNew;
    }

    //TODO 暂时存放 childrenColumnName（"子节点"） showChildren, searchValueMap[key:columnName,value:columnValue]
    function filterByNameExt(menu, searchValueMap, childrenColumnName, showChildren, nodeKeys, nodeKeyColumnName, nodeSearchColumnNames) {
        childrenColumnName = childrenColumnName == null ? 'children' : childrenColumnName;
        showChildren = showChildren == null ? false : showChildren;
        nodeKeyColumnName = nodeKeyColumnName == null ? 'nodeKey' : nodeKeyColumnName;
        nodeKeys = nodeKeys == null ? [] : nodeKeys;
        nodeSearchColumnNames = nodeSearchColumnNames == null ? ['name'] : nodeSearchColumnNames;
        //
        let menuNew = [];
        for (let i = 0; i < menu.length; i++) {
            let nodeNew = undefined;
            let node = menu[i];
            let childrenNode = node[childrenColumnName];
            //
            let childrenMenu = [];
            if (!Utils.isNoB(childrenNode) && childrenNode.length > 0) {
                childrenMenu = filterByNameExt(childrenNode, searchValueMap, childrenColumnName, showChildren, nodeKeys, nodeKeyColumnName, nodeSearchColumnNames);
            }
            if (childrenMenu.length > 0) {
                nodeNew = {};
                nodeNew = nodeFillNewFromOld(childrenColumnName, node, nodeNew);
                nodeNew[childrenColumnName] = childrenMenu;
                nodeKeys.push(node[nodeKeyColumnName]);
            } else {
                for (let j = 0; j < nodeSearchColumnNames.length; j++) {
                    let columnName = nodeSearchColumnNames[j];
                    if (typeof searchValueMap[columnName] == 'string') {//模板字符串
                        if (!Utils.isNoB(node[columnName]) && node[columnName].indexOf(searchValueMap[columnName]) != -1) {
                            nodeNew = {};
                            nodeKeys.push(node[nodeKeyColumnName]);
                            if (showChildren) {
                                nodeNew = node;
                            } else {
                                nodeNew = nodeFillNewFromOld(childrenColumnName, node, nodeNew);
                            }
                        } else {
                            nodeNew = undefined;
                            break;
                        }
                    } else if (typeof searchValueMap[columnName] == 'bool' || typeof searchValueMap[columnName] == 'boolean') {
                        if (!Utils.isNoB(node[columnName]) && node[columnName] == Utils.isTrue(searchValueMap[columnName])) {
                            nodeNew = {};
                            nodeKeys.push(node[nodeKeyColumnName]);
                            if (showChildren) {
                                nodeNew = node;
                            } else {
                                nodeNew = nodeFillNewFromOld(childrenColumnName, node, nodeNew);
                            }
                        } else {
                            nodeNew = undefined;
                            break;
                        }
                    } else if (typeof searchValueMap[columnName] == 'date') {
                        if (!Utils.isNoB(node[columnName]) && node[columnName].format('yyyy-MM-dd') == searchValueMap[columnName]) {
                            nodeNew = {};
                            nodeKeys.push(node[nodeKeyColumnName]);
                            if (showChildren) {
                                nodeNew = node;
                            } else {
                                nodeNew = nodeFillNewFromOld(childrenColumnName, node, nodeNew);
                            }
                        } else {
                            nodeNew = undefined;
                            break;
                        }
                    }
                }
            }
            if (!Utils.isNoB(nodeNew)) {
                menuNew.push(nodeNew);
            }
        }
        return menuNew;
    }

    function nodeFillNewFromOld(childrenColumnName, oldNode, newNode) {
        newNode = oldNode;
        newNode[childrenColumnName] = undefined;
        return newNode;
    }

    //----------------------------------- exports -------------------------------------
    let __to_be_exported = {
        Vue,
        VueRouter,
        setRouter,
        Routes,
        MsgBox,
        PopperJS,
        VueLazyload,
        vuedraggable,
        VirtualScroll,
        VirtualColumn,
        //
        castToJsonArray,
        convertToTypedValue,
        convertToTypedStr,
        toDependedNodeMap,
        zIndexManager,
        showPageRangeSelDlg,
        //
        setQueryResultConfStorer,
        getQueryResultConfStorer,
        //
        setComnMerchantBizTag,
        getComnMerchantBizTag,

        //
        setComnMerchantAttTag,
        getComnMerchantAttTag,

        //
        VRowId,
        findDataItemByItemKey,
        sumCommonItems,
        sumDetailItems,
        DomSizeWatcher,
        getSimpleJavaTypes,
        getSimpleJavaTypesMap,
        getInputTypes,
        getDefInputTypeNameFor,
        getColDefFormat,
        getColDefAlign,
        //
        getContentAreaSize,
        calcDomFutureCoreSize,
        calcDomWidth,
        calcDomHeight,
        getElTableHeight,
        fixElTableFixedHeight,
        //
        showQrCodeImageDlg,
        filterByName,
        filterByNameExt
    };

    Utils.merge(exports, __to_be_exported);
}));



//////////////////
// WEBPACK FOOTER
// ./src/app.vues.js
// module id = 0
// module chunks = 0